var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-page"},[_vm._m(0),_c('el-button',{staticClass:"error-btn",attrs:{"circle":"","type":"primary","size":"large","icon":"el-icon-s-help"},on:{"click":_vm.goBack}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home card"},[_c('img',{staticClass:"home-bg",attrs:{"src":require("@/assets/img/welcome.png"),"alt":"welcome"}})])
}]

export { render, staticRenderFns }